import { memo } from "react";
import { Navigate } from "react-router-dom";
import { SEND_ROUTES } from "../../constants";

/** Live send redirects the old launcher to home (inline mint on the row). */
export const CashDepositPage = memo(() => (
  <Navigate to={SEND_ROUTES.HOME} replace />
));
